<template>
    <svg class="c-a-icon">
        <use :href="`/assets/icons/icons.svg#${icon}`" :xlink:href="`/assets/icons/icons.svg#${icon}`"></use>
    </svg>
</template>

<script>
    export default {
        props: {
            icon: String
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/atoms/AtomIcon.vue